import { render, staticRenderFns } from "./qua.vue?vue&type=template&id=f6e387a6&scoped=true&"
import script from "./qua.vue?vue&type=script&lang=js&"
export * from "./qua.vue?vue&type=script&lang=js&"
import style0 from "./qua.vue?vue&type=style&index=0&id=f6e387a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e387a6",
  null
  
)

export default component.exports